import { render, staticRenderFns } from "./BusinessInformationPermit.vue?vue&type=template&id=0c46c440"
import script from "./BusinessInformationPermit.vue?vue&type=script&lang=js"
export * from "./BusinessInformationPermit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports